export const formatBytes = (bytes: number, decimals = 2, useBinary = true) => {
  if (!Number.isFinite(bytes) || bytes < 0) {
    return 'N/A';
  }

  const k = useBinary ? 1024 : 1000;
  const binarySizes = ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'] as const;
  const decimalSizes = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] as const;
  const sizes = useBinary ? binarySizes : decimalSizes;

  // Math.log(0) is -Infinity, so clamping the exponent handles 0 (and values beyond the largest unit) without special cases.
  const exponent = Math.floor(Math.log(bytes) / Math.log(k));
  const i = Math.max(0, Math.min(exponent, sizes.length - 1));
  const value = parseFloat((bytes / k ** i).toFixed(decimals));

  return `${value} ${sizes[i]}`;
};

export const formatBytesToMB = (bytes: number, decimals = 2, useBinary = true) => {
  if (!Number.isFinite(bytes) || bytes < 0) {
    return 'N/A';
  }

  const factor = useBinary ? 1024 * 1024 : 1000 * 1000;
  const unit = useBinary ? 'MiB' : 'MB';

  if (bytes === 0) {
    return `0 ${unit}`;
  }

  const valueInMB = bytes / factor;
  const formattedValue = valueInMB.toFixed(decimals);

  const formattedWithCommas = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(parseFloat(formattedValue));

  return `${formattedWithCommas} ${unit}`;
};

export const formatDecimal = (value: number, decimals = 2): string => {
  if (!Number.isFinite(value) || value < 0) {
    return 'N/A';
  }

  if (value === 0) {
    return `0`;
  }

  const formattedValue = value.toFixed(decimals);

  const formattedWithCommas = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(parseFloat(formattedValue));

  return `${formattedWithCommas}`;
};
